/**
 * Renders checkbox label text with an optional embedded link.
 * If linkText is found inside label, it becomes a clickable <a> tag.
 */
export function CheckboxLabel({ label, linkText, linkUrl, required }) {
  if (!label) return null;
  if (linkText && linkUrl && label.includes(linkText)) {
    const parts = label.split(linkText);
    return (
      <span className="text-xs text-slate-500 leading-relaxed">
        {parts[0]}
        <a href={linkUrl} target="_blank" rel="noopener noreferrer" className="text-emerald-600 underline hover:text-emerald-700">
          {linkText}
        </a>
        {parts.slice(1).join(linkText)}
        {required ? " *" : ""}
      </span>
    );
  }
  return <span className="text-xs text-slate-500 leading-relaxed">{label}{required ? " *" : ""}</span>;
}
